import { render, staticRenderFns } from "./client-footer.component.vue?vue&type=template&id=9d20b152&scoped=true"
import script from "./client-footer.component.ts?vue&type=script&lang=ts&external"
export * from "./client-footer.component.ts?vue&type=script&lang=ts&external"
import style0 from "./client-footer.component.vue?vue&type=style&index=0&id=9d20b152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d20b152",
  null
  
)

export default component.exports